// purchase-receipt
import {setPageConfig,setNowTabPageCongfig,clearRowDataDeep,getMyColums} from "@/tools/table-drag.js";
let cacheSize = parseInt(localStorage.getItem('pageSize'));
import {getRandomString,isNotEmpty} from "@/tools/utils";
const tableData = {};
const pageConfig = {
    resetPage:null,
    loading:false,
    tableName:'purchase-receipt',
    height:'',
    pageKey:getRandomString(),
    top_tools:{
        "DATA":[
            { index: 1, name: ['手动生成外购入库'], icon: 'fas fa-tasks', check_lines: 0, on_click: [], sign: 'get_client__dn_stock', },
            // { index: 0, name: ['手动更新物料'], icon: 'fas fa-sync-alt', check_lines: 0, on_click: [], sign: 'updateErpMaterial', },
            // { index: 0, name: ['导出EXCEL'], icon: 'fas fa-file-excel', check_lines: 0, on_click: [], sign: 'exportExcel', },
            // { index: 1, name: ['手动接收'], icon: 'fas fa-hand-paper', check_lines: 0, on_click: [], sign: 'handleGet', },
        ]
    },
    pageConfig:{},
    pageConfigTree:[],
}
const state = () => ({
    purchaseReceipt: Object.assign({}, tableData,pageConfig),
})
const getters = {
    getPageConfig: state => state.purchaseReceipt.pageConfig,
    getPageConfigTree: state => state.purchaseReceipt.pageConfigTree,
    getPageKey:state => state.purchaseReceipt.pageKey,
}
const mutations ={
    setRestPageFun(state, data){
        state.purchaseReceipt.resetPage = data;
    },
    setLoading(state, data){
        state.purchaseReceipt.loading = data;
        if(isNotEmpty(state.purchaseReceipt.pageConfig)){
            Object.keys(state.purchaseReceipt.pageConfig).forEach((key,index)=>{
                state.purchaseReceipt.pageConfig[key].loading = data;
            })
        }
    },
    setPageConfig(state, data){
        state.purchaseReceipt.pageConfig = data.pageConfig;
        state.purchaseReceipt.pageConfigTree = data.allArrData;
        state.purchaseReceipt.pageKey = getRandomString();
        if(isNotEmpty(state.purchaseReceipt.pageConfig)){
            Object.keys(state.purchaseReceipt.pageConfig).forEach((key,index)=>{
                state.purchaseReceipt.pageConfig[key].height = state.purchaseReceipt.height
            })
        }
    },
    setList(state, data) {
        state.purchaseReceipt.pageConfig[data.obj].data = data.data;
        state.purchaseReceipt.pageConfig[data.obj].pagination.rowsNumber = data.count;
    },
    ['refreshTableHeight'](state, data) {
        state.purchaseReceipt.height = (data) + 'px';
        if(isNotEmpty(state.purchaseReceipt.pageConfig)){
            Object.keys(state.purchaseReceipt.pageConfig).forEach((key,index)=>{
                state.purchaseReceipt.pageConfig[key].height = state.purchaseReceipt.height;
            })
        }
    },
    ['clearData'](state, data) {
        clearRowDataDeep({tabName:data.tabName,pageConfig:state.purchaseReceipt.pageConfig,pageConfigTree:state.purchaseReceipt.pageConfigTree});
    }
}
const actions = {
    ['get_client__dn_stock']({ state, dispatch, rootState ,commit}, payload) {
        if(state.purchaseReceipt.loading) return;
        commit('setLoading',true);
        let msg = { command: "get_client__dn_stock", message: {
                order_list: payload.map(item=>item.DELIVERY_NO)
            }, to: "client" }
        dispatch('channel/socket_send', msg, { root: true })
    },
    ['dn_stock_return']({ state, commit }, payload) {
        commit('setLoading',false);
        state.purchaseReceipt.resetPage({});
    },
    async ['fetch-list']({ state, dispatch, rootState ,commit}, payload) {
        if(state.purchaseReceipt.loading) return;
        commit('setLoading',true);
        let msg = { command: "get_client__dn", message: payload, to: "client" }
        dispatch('channel/socket_send', msg, { root: true })
    },
    async ['return_list']({ state, commit }, payload) {
        commit('setLoading',false);
        if (payload.success) {
            let params = JSON.parse(JSON.stringify(payload));
            if(!isNotEmpty(state.purchaseReceipt.pageConfigTree)){//生成 页面列配置 并处理成需要的结构
                let pageData = setPageConfig({pageData:payload.data.objs,tableName:state.purchaseReceipt.tableName,top_tools:state.purchaseReceipt.top_tools});
                commit('setPageConfig',pageData);
            }
            let myCoums = await getMyColums({name:state.purchaseReceipt.tableName+'-'+payload.data.obj});//获取偏好
            setNowTabPageCongfig({pageConfig:state.purchaseReceipt.pageConfig[payload.data.obj],myColums:myCoums})//设置为自己的偏好
            commit('setList',payload.data);
        }
    },
    async['export_excel']({ state, dispatch, rootState }, payload) {
        let msg = { command: "inventory__export", message: payload, to: "client" }
        dispatch('channel/socket_send', msg, { root: true })
        dispatch('response/info-tip', { message: '正在导出' }, { root: true })
    },
    async['return_inventory__export']({ state, dispatch, rootState }, payload) {
        if (payload.success) {
            window.open(payload.data, '_blank')
            dispatch('response/success-tip', { message: '导出成功' }, { root: true })
        }
    },
}
export default {
    namespaced: true,
    state,
    actions,
    mutations,
    getters
}
